import { IonThumbnail } from "@ionic/react";
import styled from "styled-components";
import { AllieThumbnailProps } from "./Thumbnail.types";

export const StyledThumbnail: any = styled(IonThumbnail)`
  --border-radius: ${(props: AllieThumbnailProps) => props.borderRadius}px;
  --size: ${(props: AllieThumbnailProps) => props.size}px;
`;
